import { render, staticRenderFns } from "./CFOApproval.vue?vue&type=template&id=1de5a012"
import script from "./CFOApproval.vue?vue&type=script&lang=js"
export * from "./CFOApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports